import React from 'react';
import { formatCurrency } from '../../../utils/formatting';
import type { InstallmentInfo } from '../../../offer.types';

interface OrderSummaryHeaderProps {
  isCollapsed: boolean;
  setIsCollapsed: (collapsed: boolean) => void;
  totalProducts: number;
  finalTotal: number;
  hasCoupon: boolean;
  installmentInfo?: InstallmentInfo;
}

export const OrderSummaryHeader: React.FC<OrderSummaryHeaderProps> = ({
  isCollapsed,
  setIsCollapsed,
  totalProducts,
  finalTotal,
  hasCoupon,
  installmentInfo,
}) => {
  return (
    <div 
      className="flex items-center justify-between p-4 cursor-pointer lg:cursor-default border-b border-gray-200 dark:border-gray-700"
      onClick={() => setIsCollapsed(!isCollapsed)}
    >
      <div className="flex items-center space-x-2">
        <button className="lg:hidden">
          <svg 
            className={`w-4 h-4 transition-transform ${isCollapsed ? 'rotate-0' : 'rotate-180'}`}
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </button>
        <div>
          <h3 className="text-base font-semibold text-text-primary dark:text-gray-100">
            Resumo do Pedido
          </h3>
          <span className="text-sm text-gray-500">
            Produtos: <span className="font-semibold">{totalProducts.toString().padStart(2, '0')}</span>
          </span>
        </div>
      </div>
      <div className="text-right">
        <div className="text-base font-bold text-green-600">
          {installmentInfo ? (
            <>
              {installmentInfo.installments > 1 ? (
                // Cartão - Mostrar parcelamento
                <>
                  <span className="text-green-600">
                    {installmentInfo.installments}x R$ {installmentInfo.installment_amount.toFixed(2).replace('.', ',')}
                  </span>
                  <div className="text-xs text-gray-500">
                    (ou R$ {installmentInfo.cash_price.toFixed(2).replace('.', ',')} à vista)
                  </div>
                </>
              ) : (
                // PIX/Boleto - Mostrar apenas valor à vista
                <span className="text-green-600">
                  R$ {installmentInfo.cash_price.toFixed(2).replace('.', ',')}
                </span>
              )}
            </>
          ) : (
            // Fallback para quando não há installmentInfo
            hasCoupon ? (
              <>
                <span className="text-green-600">
                  12x R$ {(finalTotal / 12).toFixed(2).replace('.', ',')}
                </span>
                <div className="text-xs text-gray-500">
                  (ou R$ {finalTotal.toFixed(2).replace('.', ',')} à vista)
                </div>
              </>
            ) : (
              formatCurrency(finalTotal)
            )
          )}
        </div>
      </div>
    </div>
  );
}; 